import modal from "./modal.vue";
export default {
  install: function (Vue) {
    Vue.component("modal", modal)
  }
}